(function ($) {

    window.lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy",
        threshold: 100,
        effect : "fadeIn"
    });

    function refresh_size_queries() {
        var classes = [];
        var scrollbarwidth = getScrollbarWidth();
        window_width = $(window).width() + scrollbarwidth;
        window_height = $(window).height();
        is_less_phone = (window_width <= 414);
        is_phone = (window_width <= 768);
        is_mobile = (window_width <= 992);
        is_tablet_portrait = (window_width > 768 && window_width < 992);
        is_tablet_landscape = (window_width >= 992 && window_width < 1200 && window_height <= 768);
        is_tablet = is_tablet_portrait || is_tablet_landscape;
        is_desktop = (window_width >= 1200);
        is_desktop_large = (window_width >= 1367);
        is_desktop_xxl = (window_width >= 1700 && window_height >= 800);

        if (is_less_phone) {
            classes.push('mq_less_phone');
        }
        if (is_phone) {
            classes.push('mq_phone');
        }
        if (is_mobile) {
            classes.push('mq_mobile');
        }
        if (is_tablet_portrait) {
            classes.push('mq_tablet_portrait');
        }
        if (is_tablet_landscape) {
            classes.push('mq_tablet_landscape');
        }
        if (is_tablet) {
            classes.push('mq_tablet');
        }
        if (is_desktop) {
            classes.push('mq_desktop');
        }
        if (is_desktop_large) {
            classes.push('mq_desktop_large');
        }
        if (is_desktop_xxl) {
            classes.push('mq_desktop_xxl');
        }


        $('html').removeClass('mq_less_phone');
        $('html').removeClass('mq_phone');
        $('html').removeClass('mq_mobile');
        $('html').removeClass('mq_tablet_portrait');
        $('html').removeClass('mq_tablet_landscape');
        $('html').removeClass('mq_tablet');
        $('html').removeClass('mq_desktop');
        $('html').removeClass('mq_desktop_xxl');

        $('html').addClass(classes.join(' '));

    }

    function getScrollbarWidth() {
        var outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
        document.body.appendChild(outer);
        var widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = "scroll";
        // add innerdiv
        var inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);
        var widthWithScroll = inner.offsetWidth;
        // remove divs
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    }

    function headerPosition() {
        var header = $('#header');
        var headerHeight = $('#top_bar').height();
        var scroll = $(window).scrollTop();

        if (scroll > headerHeight) {
            header.addClass('fixed');
        } else {
            header.removeClass('fixed');
        }
    }

    function novotel_miami_skip_to_content(){
        $('#skip-to-content').on('click keypress', function(e){
            var offset =  0;
            offset = $('#header_wrapper').height();
            $('html, body').animate({
                scrollTop: $('main .the_title').offset().top - offset
            }, 500);

            var key = e.which;
            if(key == 1 || key == 32){
                $('main .focus_on_skip').attr("tabindex",-1).focus();
            }
        });
    }

    function novotel_miami_language_manager_on_focus() {
        //This function is for accessibility
        document.addEventListener("keydown", function(event) {
            if(event.which == 9){
                $('.language_selector .current_language').focus(function () {
                    $('#other_languages').css({
                        'display': 'block',
                    });
                });

                // $("input.datepicker").focus(function () {
                //     $(this).attr('type', 'date');
                //     $(this).focusout(function () {
                //         $(this).attr('type', 'text');
                //     });
                // });

                //sidebar menu
                $('#open_menu').focus(function () {
                    var close_sidebar = $('#menu_sidebar_wrap .close_sidebar');
                    $('#open_menu').keyup(function (e) {
                        if (e.which == 13) {
                            close_sidebar.focus();
                        }
                    });
                    $('#menu_sidebar_wrap a:last').focusout(function () {
                        close_sidebar.focus();
                        close_sidebar.keyup(function (e) {
                            if (e.which == 13) {
                                $('#open_menu').focus();
                            }
                        });
                    });
                });


                //last element in the footer, return to the first element in the DOM
                $('footer a:last').focus(function () {
                    $('footer a:last').focusout(function(){
                        $('#skip-to-content').focus();
                    });
                });

                $('.other_languages li:last-child a').focusout(function(){
                    $('.other_languages').removeAttr('style');
                });

                $('#bookingform_sidebar_dialog input[type=submit]').focusout(function(){
                    $('#bookingform_sidebar_dialog .close_sidebar').focus();
                });

                //popup allsafe
                $('._allsafe_link').focus(function (e) {
                    e.preventDefault();
                    $('._allsafe_link').keydown(function (e) {
                        if (e.which == 13) {
                            setTimeout(function(){
                                $('.lightfeather-close-icon').focus();
                                $('._allsafe_popin_link').focus(function (e) {

                                    $('._allsafe_popin_link').focusout(function () {
                                        $('.lightfeather-close-icon').focus();
                                    });

                                });
                            },500);
                        }
                    });
                });

                //instagram feed imahes popup lightbox
                $('.sbi_link_area').focus(function (e) {
                    e.preventDefault();
                    $('.sbi_link_area').keydown(function (e) {
                        var selected_photo = $(this);
                        if (e.which == 13) {
                            setTimeout(function(){
                                $('.sbi_lb-close').focus();
                                $('.sbi_lb-close').keydown(function (e) {
                                    if (e.which == 13) {
                                        setTimeout(function(){
                                            selected_photo.focus();
                                        },2000);
                                    }
                                });
                            },2000);
                        }
                    });
                });


                //filters
                var map_filter = $('.map-pois .single_filter_container').find('a');
                var focusable_container = $('.container_focus_pois');
                var page = $("html, body");
                map_filter.focus(function (e) {
                    e.preventDefault();
                    map_filter.keydown(function (event) {
                        if (event.which == 13) {
                            focusable_container.slideDown();
                            var filter_selected = $(this);
                            setTimeout(function(){
                                focusable_container.find('a:visible:first').focus();

                                focusable_container.find('a:visible:last').focusout(function () {
                                    filter_selected.focus();
                                });

                                $('a.focusable_poi').keydown(function (ev) {
                                    if (ev.which == 13) {


                                            // page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
                                            //     page.stop();
                                            // });
                                            //
                                            // page.animate({ scrollTop: $('#map-canvas').offset().top }, 'fast', function(){
                                            //     page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
                                            // });

                                            // return false;


                                        // $('html, body').animate({
                                        //     scrollTop: $('#map-canvas').offset().top
                                        // }, 200);

                                        var element_poi_selected = $(this);
                                        var selected_poi = $(this).attr('data-poi');
                                        setTimeout(function(){
                                            google.maps.event.trigger( markers[selected_poi], 'click' );
                                            $('div[id^="#poi-"] a').attr('tabindex', '-1');
                                            $('#poi-'+ selected_poi + ' a').attr('tabindex', '0');

                                            if(selected_poi === 'hotel'){
                                                $('#poi-hotel a:first').focus();
                                                $('#poi-hotel a:last').focusout(function () {
                                                    element_poi_selected.focus();
                                                });
                                            } else {
                                                var close_poi = $('#poi-'+ selected_poi + ' .close_poi');
                                                close_poi.focus();
                                                $('#poi-'+ selected_poi + ' a:last').focusout(function () {
                                                    close_poi.focus();
                                                    close_poi.keydown(function (eve) {
                                                        if (eve.which == 13) {
                                                            element_poi_selected.focus();

                                                            // page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
                                                            //     page.stop();
                                                            // });
                                                            //
                                                            // page.animate({ scrollTop: $('#map-canvas').offset().top - 90 }, 'fast', function(){
                                                            //     page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
                                                            // });

                                                            // $('html, body').animate({
                                                            //     scrollTop: $('#map-canvas').offset().top - 90
                                                            // }, 200);
                                                        }
                                                    });
                                                });

                                            }
                                        },500);
                                    }
                                });

                            },500);
                        }
                    });
                });

            } else if(event.which == 27){
                if($('.room_wrap, .codes_wrap').hasClass('visible')){
                    // $('.close_bookingform_dropdown').hide();
                    $('.room_wrap, .codes_wrap').removeClass('visible').css('height','0');
                }
            }
        });


    }


    function novotel_miami_sidebarmenu() {
        var link = $('#open_menu');
        var wrap = $('#menu_sidebar_wrap');
        var close = wrap.find('.close_sidebar');

        if (link.length > 0 && wrap.length > 0) {
            link.on('click', function(){
                setTimeout(function () {
                    wrap.addClass('visible');
                    $('html').addClass('no_scroll');
                }, 300);

                openDialog('menu_sidebar_dialog', this);
            });

            close.on('click', function () {
                closeDialog(this);
                wrap.removeClass('visible');
                $('html').removeClass('no_scroll');
            });

        }
    }

    function openBookingform(btn) {
        var btn = $(btn);
        var sidebar = $('.bookingform_sidebar_wrap');
        var close = sidebar.find('.close');

        btn.click(function () {
            sidebar.fadeIn(function () {
                sidebar.addClass('visible');
            });
            $('html').addClass('no_scroll');

            openDialog('bookingform_sidebar_dialog', this);

            $('#bookingform_sidebar_dialog .close_sidebar').focus();
        });

        close.click(function () {
            closeDialog(this);

            sidebar.removeClass('visible');
            $(btn).focus();
            sidebar.fadeOut();
            $('html').removeClass('no_scroll');
        });

        $(document).click(function (event) {
            var closeme = true;

            if ($(event.target).closest(btn).length > 0) {
                closeme = false;
            }
            if ($(event.target).hasClass('close_bookingform_dropdown')) {
                closeme = false;
            }
            if ($(event.target).closest(sidebar.find('#bookingform_sidebar_dialog')).length > 0) {
                closeme = false;
            }
            if ($(event.target).closest($('.ui-datepicker')).length > 0) {
                closeme = false;
            }
            if ($(event.target).hasClass('ui-icon-circle-triangle-e')) {
                closeme = false;
            }
            if (closeme) {
                if (sidebar.hasClass('visible')) {
                    sidebar.removeClass('visible');
                    sidebar.fadeOut();
                    $('html').removeClass('no_scroll');
                }
            }
        });
    }

    function slideshow_on_previews(){
        var selector = $('.mini-gallery-wrapper.preview_slideshow');

        if(selector.length === 0) return false;

        selector.each(function(){
            var hasArrows = ($(this).find('.slide').length > 1);
            //slideshow setup
            $(this).slick({
                rows: 0,
                fade: false,
                arrows: hasArrows,
                dots: hasArrows,
                infinite: true,
                speed: 1200,
                nextArrow: $(this).parent().find('.next'),
                prevArrow: $(this).parent().find('.prev'),
            });
        })
    }

    function isotope_filters() {
        //isotope to filter each type of post_xx
        var container = $('#children-list .children-wrap');
        var single_box = $('.single-child-wrap .single-child-content'),
            highestBox = 0;

        if(!is_phone || (is_mobile && !is_phone && $('body').hasClass('blog'))){
            single_box.each(function (){
                var box_H = $(this);
                if(box_H.height() > highestBox) {
                    highestBox = box_H.height();
                }
            });
            single_box.height(highestBox);
        }

        var gutter = ($('body').hasClass('page-template-default'))? 40 : 20;
        container.isotope({
            layoutMode:'fitRowsCentered',
            itemSelector: '.single-child-wrap',
            transitionDuration: '0.8s',
            fitRowsCentered: {
                gutter: gutter
            }
        });

        // filter items on button click
        $('.filter_container').on('click', 'a', function () {
            var filterValue = $(this).attr('data-category');

            container.isotope({
                filter: filterValue,
            });

            $('.filter_container a').removeClass('active');
            $(this).toggleClass('active');
        });

        //filter items on select
        $('#select_filter').change(function () {
            container.isotope({filter: this.value});
        });
    }

    function isotope_filters_gallery() {

        if ($('.filter_wrapper').length === 0) return false;

        var container = $('.photo-gallery-container');

        container.isotope({
            layoutMode:'fitRowsCentered',
            itemSelector: '.single-image-wrap',
            transitionDuration: '0.8s',
            fitRowsCentered: {
                gutter: 30
            }
        });

        // filter items on button click
        $('.filter_container').on('click', 'a', function () {
            var filterValue = $(this).attr('data-category');

            container.isotope({
                filter: filterValue,
            });

            $('.filter_container a').removeClass('active');
            $(this).toggleClass('active');
        });

        //filter items on select
        $('#select_gallery_filter').change(function () {
            container.isotope({filter: this.value});
        });
    }


    function novotel_miami_minigallery_init(){
        var minigallery = $('.minigallery');
        var minigalleryWrapper = $('#minigallery_wrapper');
        if(minigalleryWrapper.length === 0) return false;

        if( minigallery.find('.slide').size() > 3  || (is_phone && minigallery.find('.slide').size() > 1)) {
            var prev_next_btn = (minigallery.find('.slide').size() > 3 || is_phone)? true : false;

            minigallery.on('init', function(event, slick){
                lazyLoadInstance.update();

            });

            minigallery.slick({
                rows: 0,
                centerMode: prev_next_btn,
                slidesToShow: 3,
                dots: prev_next_btn,
                arrows: prev_next_btn,
                infinite: true,
                variableWidth: true,
                lazyLoad: 'progressive',
                nextArrow: $('.container_minigallery').find('.next'),
                prevArrow: $('.container_minigallery').find('.prev'),
                accessibility: true,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            arrows: true,
                            infinite:true,
                        }
                    },
                ]
            });
        }

    }

    function novotel_miami_children_carousel_init(){
        var boxes = $('#children-list .do_carousel');
        var boxesWrapper = $('#children-list');
        if(boxesWrapper.length === 0) return false;

        var condition;
        if(!is_phone){
            condition = (boxes.find('.single-child-wrap').size() > 3);
        } else {
            condition = (boxes.find('.single-child-wrap').size() > 1);
        }
        var breckP = 769;

        if($('body').hasClass('single-post_meeting_rooms') && $(window).width() < 828 && $(window).width() > 768){
            condition = (boxes.find('.single-child-wrap').size() > 2);
            breckP = 828;
        }

        if(condition) {
            boxes.on('init', function (event, slick) {
                lazyLoadInstance.update();

                setTimeout(function(){
                    boxes.find('a.title-link').each(function(){
                        $(this).attr('tabindex','-1');
                    });
                }, 300);
            });

            boxes.on('afterChange', function (event, slick, currentSlide, nextSlide){
                setTimeout(function(){
                    boxes.find('a.title-link').each(function(){
                        $(this).attr('tabindex','-1');
                    })
                }, 300);
            });

            boxes.slick({
                rows: 0,
                centerMode: true,
                slidesToShow: 3,
                dots: true,
                arrows: true,
                infinite: true,
                variableWidth: true,
                lazyLoad: 'progressive',
                nextArrow: $('.container_carousel').find('.next'),
                prevArrow: $('.container_carousel').find('.prev'),
                accessibility: true,
                responsive: [{
                        breakpoint: breckP,
                        settings: {
                            slidesToShow: 1,
                    }},
                ]
            });
        }
    }

    function novotel_miami_carousel_page_preview_init(){
        var boxes = $('#carousel_preview_pages .do_carousel');
        var boxesWrapper = $('#carousel_preview_pages');
        if(boxesWrapper.length === 0) return false;

        var condition;
        if(!is_phone){
            condition = (boxes.find('.single-child-wrap').size() > 3);
        } else {
            condition = (boxes.find('.single-child-wrap').size() > 1);
        }
        if(condition) {
            boxes.on('init', function (event, slick) {
                lazyLoadInstance.update();

                setTimeout(function(){
                    boxes.find('a.title-link').each(function(){
                        $(this).attr('tabindex','-1');
                    })
                }, 300);

            });
            boxes.on('afterChange', function (event, slick, currentSlide, nextSlide){
                setTimeout(function(){
                    boxes.find('a.title-link').each(function(){
                        $(this).attr('tabindex','-1');
                    })
                }, 300);
            });

            boxes.slick({
                rows: 0,
                centerMode: true,
                slidesToShow: 3,
                dots: true,
                arrows: true,
                infinite: true,
                variableWidth: true,
                lazyLoad: 'progressive',
                nextArrow: boxesWrapper.find('.next'),
                prevArrow: boxesWrapper.find('.prev'),
                accessibility: true,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            arrows: true,
                            infinite:true,
                        }
                    },
                ]
            });
        }
    }

    function novotel_miami_meeting_table_select() {
        var select_capacity = $('#select_capacity');
        if(select_capacity.length === 0) return false;

        var init_value = select_capacity.val();
        $('.flex-table .flex-row.'+init_value).css({display: "flex"});

        select_capacity.change(function(){
            var changed_val = $(this).val();
            $('.flex-table .flex-row:not(.first)').hide();

            $('.flex-table .flex-row.'+changed_val).css({display: "flex"});

        })
    }

    function novotel_miami_adjust_table_rows(){
        if(is_phone){
            $('.flex-table .flex-row:not(.first)').css('width', '45vw');
        } else {
            var total_capacities = $('.flex-table.header.hide_mobile .flex-row:not(.first)').length;
            var w_total = $('#tabs_meeting').width();
            var w_first_row = $('.flex-table.header.hide_mobile .flex-row.first').outerWidth(true); //padding & margin
            if(total_capacities > 0){
                var $num_max_rows = (total_capacities >= 8)? 8 : total_capacities;
                var $width_single_item = (w_total - w_first_row) / $num_max_rows;

                $('.flex-table .flex-row:not(.first)').css('width', $width_single_item);
            }
        }
    }


    //submit form newsletter Revinate
    function novotel_miami_revinate_newsletter_form() {
        var form_initial = $('#revinate_contact_api_form');
        if (form_initial.length===0) return false;

        $('#fake_newsletter_submit').click(function (event) {
            event.preventDefault();
            // Serialize the form data.
            var formData = form_initial.serializeArray();
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            var condition_email = false;
            var conditon_consent = false;

            if(formData[0].value !== '' && regex.test(formData[0].value)){
                condition_email = true;
                $('.container_email .error-message').slideUp();
            } else {
                condition_email = false;
                $('.container_email .error-message').slideDown();
            }

            if(formData[1] && formData[1].value === 'on') {
                conditon_consent = true;
                $('.conteiner_consent .error-message').slideUp();
            } else {
                conditon_consent = false;
                $('.conteiner_consent .error-message').slideDown();
            }
            if(condition_email && conditon_consent){
                $('.error-message').slideUp();
                form_initial.submit();
            }
        });
    }




    function novotel_miani_open_form_passed_in_url(){

        if(novotel_miami_forms !== null && novotel_miami_forms) {
            //if there is a chosen form passed by the url, open that, if not, the first available form opens
            var curr_url = window.location.href;
            curr_url = curr_url.split('?openform=')[1];

            if (curr_url !== undefined) {
                $('a[href="#form-' + curr_url + '"]').trigger('click');
                $('#select_form_toshow').val('#form-' + curr_url + '').trigger('change');

                $('html, body').animate({
                    scrollTop: $('.contact_forms').offset().top - 100
                }, 500);
            } else {
                var first_form = novotel_miami_forms[0];
                $('a[href="#form-' + first_form + '"]').trigger('click');
                $('#select_form_toshow').val('#form-' + first_form + '').trigger('change');
            }
        }

    }

    function novotel_miami_check_quicksearch(){

        if($('body').hasClass('home')){
            if(!is_mobile) {
                $('.bookingform_sidebar_wrap:not(.visible)').show();
                $('.bookingform_vertical').addClass('bookingform_horizontal').removeClass('bookingform_vertical');

                $('#main_book').click(function(){
                    $('html, body').animate({
                        scrollTop: $('form.bookingform').offset().top -120
                    }, 500, function(){
                        $('.input_arrival').focus();
                    });
                });
            } else {
                $('.bookingform_sidebar_wrap:not(.visible)').hide();
                $('.bookingform_horizontal').addClass('bookingform_vertical').removeClass('bookingform_horizontal');
                openBookingform('#main_book');
            }
        } else {
            openBookingform('#main_book');
        }
    }

    $(document).ready(function () {

        window.sb_instagram_js_options = {
            font_method: "svg",
            resized_url: location.protocol + '//' + window.location.hostname + "/wp-content/uploads/sb-instagram-feed-images/",
            placeholder: location.protocol + '//' + window.location.hostname + "/wp-content/themes/novotel-miami/css/images/placeholder.png",
            br_adjust: ""
        };


        refresh_size_queries();
        headerPosition();
        novotel_miami_skip_to_content();
        novotel_miami_sidebarmenu();
        novotel_miami_revinate_newsletter_form();

        novotel_miami_check_quicksearch();

        //accessibility aria-expanded
        $( ".language_selector" ).hover(
            function() {
                if($('#other_languages:visible').length > 0){
                    $('.current_language').attr('aria-expanded', 'true');
                } else {
                    $('.current_language').attr('aria-expanded', 'false');
                }
            }, function() {
                $('.current_language').attr('aria-expanded', 'false');
            }
        );


        if($('body').hasClass('single-post_rooms') || $('body').hasClass('page-template-template-meeting_type') || $('body').hasClass('single-post_meeting_rooms')){

            novotel_miami_minigallery_init();
            novotel_miami_children_carousel_init();
        }

        if($('body').hasClass('home')){
            novotel_miami_children_carousel_init();

            novotel_miami_carousel_page_preview_init();
        }

        if($('body').hasClass('single-post_events') || $('body').hasClass('page-template-default')){
            novotel_miami_minigallery_init();
        }

        if($('body').hasClass('page-template-template-meeting_type')){
            novotel_miami_adjust_table_rows();

            var tab_to_open = ($("#tabs_meeting").hasClass('list'))? 1 : 0;
            $("#tabs_meeting").tabs({active: tab_to_open});

            $('a[href="#tabs-list"]').click(function(){
                if(!is_phone){
                    var single_box = $('#tabs_meeting_rooms .single-child-content'),
                        highestBox = 0;

                    single_box.each(function (){
                        var box_H = $(this);
                        if(box_H.height() > highestBox) {
                            highestBox = box_H.height();
                        }
                    });
                    single_box.height(highestBox);
                }
            });

            if(is_phone) {
                novotel_miami_meeting_table_select();

                $('a[href="#tabs-table"]').click(function(){
                    novotel_miami_meeting_table_select();
                });
            }
        }

        if($('body').hasClass('page-template-template-gallery')){
            isotope_filters_gallery();
        }

        if($('body').hasClass('page-template-template-contacts') || $('body').hasClass('page-template-template-form-page')){
             $('.do_tabs_here').tabs();

            if(is_phone){
                $('#select_form_toshow').on("change", function() {
                    var selected_form = $(this).val();
                    $('div[id^="form-"]').hide();
                    $(selected_form).show();
                })
            }

            if($('div[id^="form-"]').length <= 1){
                $('.ui-tabs-nav, .mobile_form_selector').hide();
            }


            $("input.datepicker").datepicker({
                inline: true,
                dateFormat: "mm/dd/yy",
                minDate: new Date(),
            }).attr('maxlength', '10').attr('pattern', '(?:30))|(?:(?:0\\[13578\\]|1\\[02\\])-31))/(?:0\\[1-9\\]|1\\[0-9\\]|2\\[0-9\\])|(?:(?!02)(?:0\\[1-9\\]|1\\[0-2\\])/(?:19|20)\\[0-9\\]{2}-(?:(?:0\\[1-9\\]|1\\[0-2\\])');


            $('.starting_date input, .end_date input, .ginput_container_date input').datepicker('option', 'minDate', 0);


            $(".starting_date input").on("change", function() {
                var date = $(this).val();
                $(".end_date input").datepicker('option', 'minDate', date);
            });

            $("input.datepicker").on('keyup', function (e) {
                var textSoFar = $(this).val();
                if (e.keyCode != 191) {
                    if (e.keyCode != 8) {
                        if (textSoFar.length == 2 || textSoFar.length == 5) {
                            $(this).val(textSoFar + "/");
                        }
                        //to handle copy & paste of 8 digit
                        else if (e.keyCode == 86 && textSoFar.length == 8) {
                            $(this).val(textSoFar.substr(0, 2) + "/" + textSoFar.substr(2, 2) + "/" + textSoFar.substr(4, 4));
                        }
                    }
                    else {
                        //backspace would skip the slashes and just remove the numbers
                        if (textSoFar.length == 5) {
                            $(this).val(textSoFar.substring(0, 4));
                        }
                        else if (textSoFar.length == 2) {
                            $(this).val(textSoFar.substring(0, 1));
                        }
                    }
                } else {
                    //remove slashes to avoid 12//01/2014
                    $(this).val(textSoFar.substring(0, textSoFar.length - 1));
                }
                if(textSoFar.length == 10){
                    var GivenDate = textSoFar.substring(6, 10) + '-' + textSoFar.substring(3, 4) +'-'+ textSoFar.substring(0, 1);
                    var CurrentDate = new Date();
                    GivenDate = new Date(GivenDate);

                    if(GivenDate < CurrentDate){
                        var date = (CurrentDate.getDate() < 10)? '0' + CurrentDate.getDate() : CurrentDate.getDate();
                         date += '/';
                         date += ((CurrentDate.getMonth() +1) < 10)? '0' + (CurrentDate.getMonth()+1) : (CurrentDate.getMonth()+1);
                         date += '/';
                         date += CurrentDate.getFullYear();
                        $(this).val(date);
                    }
                }
            });


            $('div[id^="form-"]').each(function(){
                var required = true;
                if(required){
                    var fields = $(this).find('form li:not(.gform_validation_container)');
                    fields.each(function(){
                        if(! $(this).hasClass('gfield_contains_required')){
                            required = false;
                            return false;
                        }
                    })
                } else {
                    return false;
                }

                if(required){
                    $(this).find('.mandatory_fields').hide();
                }
            });

            novotel_miani_open_form_passed_in_url();

            $('input.datepicker').attr('placeholder', '');
        }

        if($('body').hasClass('page-template-template-faq')){
            // $( ".do_accordion_here" ).accordion();
            $(".do_accordion_here").accordion({
                header: "> .title_to_open",
                heightStyle: "content",
                active: false,
                collapsible: true
            });
        }

        if(!is_mobile){
            $('.menu_sidebar a').each(function(){
                $(this).attr('tabindex', '-1');
            })
        } else {
            $('.menu_sidebar a').each(function(){
                $(this).attr('tabindex', '0');
            })
        }

    });

    $(window).scroll(function () {
        headerPosition();
    });

    $(window).on('load', function () {
        novotel_miami_language_manager_on_focus();

        if($('body').hasClass('home')){
            $('img.sbi_lb-image').attr('src',  theme_url + '/css/images/placeholder.png');

            if(is_mobile){
                var observer = new MutationObserver(function(mutations) {
                    mutations.forEach( function(mutation) {
                        if (mutation.attributeName !== 'style') return;
                        var currentValue = mutation.target.style.display;

                        if(currentValue == 'block'){
                            $('html').addClass('no_scroll')
                        } else {
                            $('html').removeClass('no_scroll');
                        }
                    });


                });
                var target = document.querySelector('#sbi_lightbox');
                observer.observe(target, {
                    attributes: true,
                });
            }
        }

        if($('body').hasClass('page-template-template-rooms')){
            isotope_filters();

            slideshow_on_previews();
        }
        if($('body').hasClass('page-template-template-events') || ($('body').hasClass('page-template-default') && !$('body').hasClass('home')) || $('body').hasClass('blog')){
            isotope_filters();
        }
    });

    $(window).resize(function () {
        refresh_size_queries();
        novotel_miami_check_quicksearch();

        if($('body').hasClass('page-template-template-meeting_type')) {
            novotel_miami_adjust_table_rows();
            if(is_phone) {
                novotel_miami_meeting_table_select();
            } else {
                $('.flex-table .flex-row').css({display: "flex"});
            }
        }

        if($('body').hasClass('single-post_rooms') || $('body').hasClass('page-template-template-meeting_type') || $('body').hasClass('single-post_meeting_rooms') || $('body').hasClass('single-post_events') || $('body').hasClass('page-template-default')) {
            novotel_miami_minigallery_init();
        }
    });




})(jQuery);